import { ZObjTableSettings } from "./ObjTableSettingsTypes";

export const reconcileObjTableSettings = (
  settings: ZObjTableSettings,
  availableColumnIds: Set<string>,
  sortableAttributeIds: Set<string>,
): ZObjTableSettings => {
  const seenIds = new Set<string>();
  const displayAttributes = settings.displayAttributes.filter(({ id }) => {
    if (id === null) return false;
    const key = String(id);
    if (!availableColumnIds.has(key) || seenIds.has(key)) return false;
    seenIds.add(key);
    return true;
  });
  const sort =
    settings.sort && sortableAttributeIds.has(String(settings.sort.attributeId))
      ? settings.sort
      : null;

  return {
    ...settings,
    sort,
    displayAttributes,
  };
};
